import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/patterns/Icon'
import { Menu, MenuOption, MenuOptionTitle } from './OverflowMenu.style'

const OverflowMenu = ({
  openTrigger,
  handleSelect,
  options,
  message,
  icon,
}) => {
  const renderOption = (displayProps) => {
    const { icon, title, iconFill } = displayProps

    return (
      <MenuOption>
        {icon && <Icon icon={icon} fill={iconFill} />}
        <MenuOptionTitle size="small">{title}</MenuOptionTitle>
      </MenuOption>
    )
  }

  const processOptionData = () =>
    options.map((option) => {
      const { key, display, displayProps, onClick, disabled, type } = option

      return {
        key,
        display: displayProps ? renderOption(displayProps) : display,
        onClick,
        disabled,
        type,
      }
    })

  return (
    <Menu
      trigger={openTrigger}
      clickHandler={handleSelect}
      options={processOptionData()}
      message={message}
    >
      {icon || <Icon icon="overflow-menu-vertical" />}
    </Menu>
  )
}

OverflowMenu.propTypes = {
  openTrigger: PropTypes.oneOf(['hover', 'click']),
  handleSelect: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      displayProps: PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
      }),
      display: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    })
  ),
  message: PropTypes.string,
  icon: PropTypes.node,
}

OverflowMenu.defaultProps = {
  openTrigger: 'click',
  handleSelect: null,
}

export default OverflowMenu
